import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { SavedQueryService } from "@app2/search/saved-query.service";
import { SavedQuery } from "@app2/type-defs/search/search-types";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: "saved-query-summary",
    template: `
        <div *ngIf="savedQuery"
             class="flex-container declutter">
            <div>
                <div class="saved-query-name" test-class="query-name">
                    <saved-query-icon [savedQueryId]="savedQueryId"></saved-query-icon>
                    {{ this.name ? this.name : savedQuery.name }}
                </div>
                <div class="saved-query-string" test-class="query-string"
                     *dsPermissionsRequired="'!EVENT_VIEW'">
                    {{ this.query ? this.query : savedQuery.query }}
                </div>
                <div class="flex-container">
                    <search-link class="saved-query-string" test-class="query-string"
                                 *dsPermissionsRequired="'EVENT_VIEW'"
                                 [queryString]="savedQuery.query"
                                 [primaryField]="savedQuery.primaryField"
                                 [linkClass]="false"
                                 [newTab]="true">
                        {{ this.query ? this.query : savedQuery.query }}
                    </search-link>
                    <span *ngIf="showEdit || showRemove" class="action-icons show-on-hover">
                        <i *ngIf="showEdit"
                           class="fal fa-pen primary click-target margin-right"
                           (click)="editClicked.emit()"
                           test-id="edit-saved-query"></i>
                        <i *ngIf="showRemove"
                           class="fa fa-times alert click-target"
                           (click)="removeClicked.emit()"
                           test-id="remove-saved-query"></i>
                    </span>
                </div>
                <div *ngIf="savedQuery.primaryField"
                     class="saved-query-aggregation"
                     test-class="query-primary-field">
                    {{ 'AGGREGATE_BY' | localize }}
                    <span class="aggregation-field">{{ savedQuery.primaryField }}</span>
                    <span class="aggregation-field"
                          *ngIf="savedQuery.secondaryField">{{ savedQuery.secondaryField }}</span>
                </div>
            </div>
        </div>
    `,
    styles: [`
      .action-icons {
        display: flex;
        height: 16px;
        align-items: center;
        margin-left: 16px;
        font-size: 0.75rem;
      }

      .saved-query-string {
        display: inline-block;
      }
    `],
})
export class SavedQuerySummaryComponent implements OnChanges {
    @Input() savedQueryToDisplay: SavedQuery;
    @Input() savedQueryId: uuid;
    @Input() showEdit = false;
    @Input() showRemove = false;
    @Input() name: string;
    @Input() query: string;

    @Output() editClicked = new EventEmitter<void>();
    @Output() removeClicked = new EventEmitter<void>();

    constructor(private savedQueryService: SavedQueryService) {
    }

    savedQuery: Partial<SavedQuery> = {};

    ngOnChanges(changes: SimpleChanges) {
        if (changes.savedQueryToDisplay) {
            this.savedQuery = this.savedQueryToDisplay;
        } else if (changes.savedQueryId) {
            this.savedQueryService.getSavedQuery$(this.savedQueryId)
                .pipe(untilDestroyed(this))
                .subscribe(savedQuery => this.savedQuery = savedQuery);
        }
    }
}
